import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MemberListItem } from "../../algorithms/listsAlogrithms";
import { customStyle, styleStart } from "../../algorithms/styleDirection";
import { resolver } from "../../API/middlewares/resolveRequests";
import {
  addRoleToCommunityMembers,
  communityMembers,
  communityRoles,
} from "../../API/store/actions/community";
import Lang from "../../userPreferences/staticWords";
import Button from "../sharedComponents/buttons/button";
import DropDownList from "../sharedComponents/dropdown/dropdown";
const CommunityRoles = ({ userToken, modalVisible, setModalVisible }) => {
  const communityId = useSelector((state) => state.community.communityId?.id);

  const [rolesData, setRolesData] = useState(null);
  const [roleUsers, setRoleUsers] = useState([]);
  const [communityUsers, setCommunityUsers] = useState([]);
  const [roledepend, setRoledepend] = useState(null);

  useEffect(() => {
    resolver(communityRoles, setRolesData, userToken);
  }, []);
  const [disable, setDisable] = useState(false);
  useEffect(() => {
    setCommunityUsers(null);
    if (roledepend) {
      resolver(
        communityMembers,
        setCommunityUsers,
        roledepend,
        communityId,
        userToken
      );
    }
  }, [roledepend]);
  useEffect(() => {
    setRoleUsers([]);
    if (communityUsers?.data?.selectedMembers)
      setRoleUsers([
        ...roleUsers,
        ...communityUsers?.data?.selectedMembers.map((item) => item.userId),
      ]);
  }, [communityUsers]);
  const submit = async () => {
    if (disable) {
      return;
    } else {
      setDisable(true);
    }
    let res = await addRoleToCommunityMembers(
      roledepend,
      communityId,
      roleUsers,
      userToken
    );
    if (res.status <= 206) {
      toast.success("تم التعديل بنجاح", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setDisable(false);
    } else {
      toast.error("حدث خطا اثناء التعديل", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setDisable(false);
    }
  };
  if (rolesData)
    return (
      <>
        <DropDownList
          dataSource={rolesData?.data?.map((item, index) => {
            return { ...item, name: Lang[item.name] };
          })}
          placeholder={"الصلاحيات"}
          containerStyle={" mx-xl-4 mx-3  "}
          change={(item) => {
            setRoledepend(item.value);
          }}
        />
        {communityUsers ? (
          <>
            <div className={"d-flex flex-column mx-xl-4 mx-3 my-4 col-12"}>
              <div className={`d-flex px-3 col-11 mb-3 ${styleStart("m", 2)}`}>
                <p className="my-0">{"البرامج البحثية"}</p>
              </div>

              <div
                className={`d-flex flex-column col-11 px-3 py-2 mx-1 mx-lg-3 mx-xl-4 ${customStyle(
                  "TitleCard"
                )}`}
                style={{
                  height: "fit-content",
                  maxHeight: 250,
                }}
              >
                <div className="d-flex flex-column scroll py-3">
                  {communityUsers?.data?.allMembers?.map((item, index) => {
                    let communityPhoto = `url("/assets/images/icons/access-granted.png")`;
                    return (
                      <MemberListItem
                        key={index}
                        id={item.userId}
                        photo={item?.logo ?? communityPhoto}
                        index={index}
                        name={item.memberName}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          const value = e.target.value;
                          if (checked) {
                            setRoleUsers([...roleUsers, value]);
                          } else {
                            setRoleUsers(
                              roleUsers.filter((item) => item != value)
                            );
                          }
                        }}
                        values={roleUsers}
                        length={
                          communityUsers?.data?.allMembers?.length - index
                        }
                        checked={true}
                        idChar={"B"}
                      />
                    );
                  })}
                </div>
                <div style={{ fontSize: 14, color: "red" }}></div>
              </div>
            </div>
            <div className="d-flex justify-content-center  ">
              <Button
                disable={disable}
                content={disable ? Lang.saving : Lang.save}
                buttonStyleType="solid"
                onClick={() => {
                  submit();
                }}
                containerStyle={"m-3 col-3 "}
              />
              <Button
                content={Lang.cancel}
                onClick={() => {
                  setModalVisible(!modalVisible);
                  setDisable(false);
                }}
                containerStyle={"m-3 col-3 "}
              />
            </div>{" "}
          </>
        ) : (
          <div className="text-center py-2"> اختر صلاحية </div>
        )}
      </>
    );

  return <>LOADING</>;
};

export default CommunityRoles;
